<div class="row">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title">{{ 'SUBSC.SUBSC_CREATE.SUBS_CREATE' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light mr-2 btn-sm btn-back"  (click)="backTo()">
                        <!-- <i class="bi bi-arrow-left-square"></i> -->
                        {{ 'BACK' | translate }}
                      </button>
                    <button type="button" class="btn btn-primary btn-sm btn-create" (click)="onCreate()" [disabled]="form.invalid || !ffInputLang.valid">
                        <!-- <i class="bi bi-save"></i> -->
                         {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                    <div class="row">

                        <div class="col-10">
                            <div class="form-group">
                                <ff-input-lang
                                    label="{{ 'SUBSC.SUBS_NAME' | translate }}"
                                    hint="{{ 'SUBSC.SUBSC_CREATE.SUBS_NAME_OF_ALL_LANG' | translate }}"
                                    fieldId="name"
                                    fieldName="name"
                                    fieldType="text"
                                    [clearField]="ffInputLangParams.name.clearField"
                                    [required]="ffInputLangParams.name.required"
                                    [inputValue]="attributeName" 
                                    (changeValue)="eventFnFF('name', $event)">
                                </ff-input-lang>
                            </div>
                        </div>

                            <div class="col-12">
                                <div class="form-group">
                                    <label class="filter-label" for="discription">{{ 'SUBSC.SHORT_DESCRIPTION' | translate }} :</label>
                                    <textarea class="form-control" type="text" formControlName="discription"></textarea>
                                </div>
                            </div>

                            <div class="col-4">
                                <div class="form-group">
                                    <label class="filter-label"> {{ 'TYPE' | translate }}:</label>
                                    <ng-select 
                                    id="type_id" 
                                    class="custom" 
                                    clearAllText="{{ 'NO_DATA' | translate }}"
                                    notFoundText="{{ 'CLEAR' | translate }}"
                                    bindLabel="name" 
                                    bindValue="id"
                                    formControlName="type" 
                                    [multiple]="false" 
                                    [items]="types">
                                    </ng-select>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="form-group">
                                    <label for="second_name"> {{ 'SUBSC.SUBSC_CREATE.PERIOD_START' | translate }}</label>
                                    <div class="input-group">
                                        <input class="form-control"  formControlName="start_date" id="start_date" readonly="true" ngbDatepicker #dS="ngbDatepicker">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary calendar" (click)="dS.toggle()" type="button">
                                                <i class="bi bi-calendar-event"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="form-group">
                                    <label for="second_name"> {{ 'SUBSC.SUBSC_CREATE.PERIOD_END' | translate }}</label>
                                    <div class="input-group">
                                        <input class="form-control" formControlName="end_date" id="end_date" readonly="true" ngbDatepicker #dE="ngbDatepicker">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary calendar" (click)="dE.toggle()" type="button">
                                                <i class="bi bi-calendar-event"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        <div class="col-12">

                            <div class="service-edge form-group">
                                <label for="service-title" class="filter-label"><span> {{ 'SUBSC.SUBSC_CREATE.SERVICES_AVIILABLE' | translate }}: </span></label>
                            </div>
                            <div formArrayName="services">

                                <div *ngFor="let item of form.get('services')['controls']; let i = index;">
                
                                    <div class="row" [formGroupName]="i">

                                        <div class="col-4">
                                            <div class="form-group">
                                                <label class="filter-label" for="service_id"><span class="star">*</span> {{ 'SUBSC.SUBSC_CREATE.NAME_OF_SERVISE' | translate }}:</label>
                                                <ng-select 
                                                id="service_id" 
                                                class="custom" 
                                                clearAllText="{{ 'NO_DATA' | translate }}"
                                                notFoundText="{{ 'CLEAR' | translate }}" 
                                                bindLabel="name" 
                                                bindValue="id"
                                                formControlName="service_id" 
                                                [multiple]="false" 
                                                [items]="serviceItems">
                                                </ng-select>
                                            </div>
                                        </div>
                                        
                                        <div class="col-3">
                                            <div class="form-group custom">
                                                <label class="filter-label" for="legal_form_id">"{{ 'SUBSC.SUBSC_CREATE.AMOUT' | translate }}":</label>
                                                <input type="text" class="form-control" id="amount" formControlName="amount" />
                                            </div>
                                        </div>

                                        <div class="col-3">
                                            <div class="form-group">
                                                <label class="filter-label" for="legal_form_id"> {{ 'SUBSC.SUBSC_CREATE.COST' | translate }}:</label>
                                                <input type="text" class="form-control" id="cost" formControlName="cost" />
                                            </div>
                                        </div>

                                        <div class="col-1">
                                            <div class="remove-service-field" *ngIf="form.get('services').value.length > 1">
                                                <button type="button" class="btn btn-danger" (click)="removeServiceField(i)"> 
                                                    <i class="bi bi-trash"></i> {{ 'SUBSC.SUBSC_CREATE.NAME_OF_SERVISE' | translate }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                    <div class="row">
                        <div class="col-12">
                            <div class="add-service-field" *ngIf="form.get('services').value">
                                <button type="button" class="btn btn-primary btn-sm" (click)="addServiceFields()"> 
                                    <i class="bi bi-plus-circle"></i> {{ 'SUBSC.SUBSC_CREATE.ADD_OF_SERVISE' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</div>